import axios from 'axios';

export const state = () => ({
  addresses: []
})

export const mutations = {
  setAddresses(state, addresses) {
    state.addresses = addresses
  }
}

export const getters = {
  getAddresses(state) {
    return state.addresses
  }
}

export const actions = {
  async getAddresses({ commit }) {
    const data = await axios.get('/api/custom-addresses', {})

    commit('setAddresses', data)
  }
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};
